export enum BatchProcessUrls {
  URL_BATCHES_V1 = 'processes/batches',
  URL_BATCHES_V2 = 'new_configuration_layout?tabName=Proceso por lotes'
}
